import React, { ReactElement } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import i18next from 'i18next';
import SuperAdminEnduranceTrainingTypes from '../components/SuperAdminEnduranceTrainingTypes';
import SuperAdminExerciseCategories from '../components/SuperAdminExerciseCategories';
import TenantSettings from '../components/TenantSettings';
import SuperAdminExerciseTags from '../components/SuperAdminExerciseTags';
import SuperAdminExercises from '../components/SuperAdminExercises';
import PromQuestionManagement from '../../../components/promQuestion/PromQuestionManagement';

const SuperAdminPage = (): ReactElement => {
  return (
    <div className="w-100 mx-auto bg-white p-4" style={{ maxWidth: '90vw' }}>
      <Tabs defaultActiveKey='exercises' id='admin-sections' mountOnEnter={true}>
        <Tab eventKey='exercises' title={i18next.t('superAdminPage.exercises')}>
          <SuperAdminExercises />
        </Tab>
        <Tab eventKey="exerciseTags" title={i18next.t('superAdminPage.exerciseTags')}>
          <SuperAdminExerciseTags />
        </Tab>
        <Tab eventKey='exerciseCategories' title={i18next.t('superAdminPage.exerciseCategories')}>
          <SuperAdminExerciseCategories />
        </Tab>
        <Tab eventKey='enduranceTrainingTypes' title={i18next.t('superAdminPage.enduranceTrainingTypes')}>
          <SuperAdminEnduranceTrainingTypes />
        </Tab>
        <Tab eventKey='promQuestions' title={i18next.t('superAdminPage.promQuestions')}>
          <PromQuestionManagement />
        </Tab>
        <Tab eventKey='tenantSettigs' title={i18next.t('superAdminPage.tenantSettings')}>
          <TenantSettings />
        </Tab>
      </Tabs>
    </div>
  );
};

export default SuperAdminPage;
